<template>
    <div :class="inputClass">
        <common-icon :class="iconClass" name="calendar" size="medium"></common-icon>
        <date-range-picker
            ref="drp"
            v-model="dateRange"
            :opens="openSide"
            :appendToBody="appendToBody"
            :calculatePosition="positionDropdown"
            :ranges="false"
            :autoApply="false"
            :singleDatePicker="isSingle"
            :dateFormat="dateClass"
            :localeData="localeData"
            @update="change($event)"
        ></date-range-picker>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],
        components: {
            DateRangePicker,
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            openSide: { type: String, default: 'left', validator: (value) => ['left', 'right'].includes(value) },
            appendToBody: { type: Boolean, default: false },
            isSingle: { type: Boolean, default: false },
            dateFormat: { type: String, default: 'mmm dd, yyyy' },
            allowedDays: {
                type: Array,
                default: undefined,
                validator: (value) => !value || value.every((v) => !isNaN(v) && v < 7),
            },
            minDate: { type: Date, default: undefined },
            maxDate: { type: Date, default: undefined },
            iconCustomClass: { type: String, default: 'picker-icon' },
        },
        data() {
            return {
                dateRange: this.value,
                localeData: {
                    firstDay: 1,
                    format: this.dateFormat,
                    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                },
            }
        },
        computed: {
            inputClass() {
                return {
                    'form-input-daterange': true,
                }
            },

            iconClass() {
                return {
                    'picker-icon': true,
                    [this.iconCustomClass]: true,
                }
            },
        },
        methods: {
            positionDropdown(dropdownList, component, { top, left, right }) {
                const margin = 8
                const calendarWidth = dropdownList.getBoundingClientRect().width || 560
                const minLeft = window.scrollX + margin
                const maxLeft = window.scrollX + window.innerWidth - calendarWidth - margin
                let nextLeft = component.opens === 'left' ? right - calendarWidth : left

                if (nextLeft > maxLeft) nextLeft = maxLeft
                if (nextLeft < minLeft) nextLeft = minLeft

                dropdownList.style.left = `${nextLeft}px`
                dropdownList.style.right = 'auto'
                dropdownList.style.top = `${top}px`
            },

            dateClass(classes, date) {
                const d = new Date(date)
                classes.disabled = this.allowedDays && !this.allowedDays.includes(d.getDay())
                classes.disabled =
                    classes.disabled || (!!this.minDate && d < this.minDate) || (!!this.maxDate && d > this.maxDate)
                return classes
            },
        },

        watch: {
            value() {
                this.dateRange = {
                    startDate: new Date(this.value.startDate),
                    endDate: new Date(this.value.endDate),
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .form-input-daterange {
        position: relative;
    }

    .picker-icon {
        position: absolute;
        z-index: 1;
        top: 1.125em;
    }

    .availability-schedule-form-icon {
        transform: translateY(-40px);
        position: relative;
    }
</style>
